// Pagos a meses sin intereses (snippets/price-msi.liquid).
// - Al cambiar el plazo en un selector se actualiza el pago mensual y los demás selectores de la página.
// - window.BarradasMsi.render(bloque, precio) recalcula el bloque cuando cambia la variante (product-price.js).
if (!window.BarradasMsi) {
  const format = (cents, noConvert) =>
    window.Shopify && typeof Shopify.showPrice === 'function'
      ? Shopify.showPrice(cents, noConvert)
      : '$' + (cents / 100).toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

  const terms = (block) =>
    (block.dataset.msiTerms || '')
      .split(',')
      .map((t) => t.split(':').map(Number))
      .filter(([n, min]) => n > 0 && min >= 0);

  const showSelected = (select) => {
    const block = select.closest('.price-msi');
    const option = select.selectedOptions[0];
    if (block && option) block.querySelector('.price-msi__amount').innerHTML = option.dataset.amount;
  };

  let preferred = null; // plazo elegido por el cliente en esta página

  const api = {
    render(block, price, noConvert = false) {
      const select = block.querySelector('.price-msi__select');
      const current = Number(preferred || select.value);
      const available = terms(block).filter(([, min]) => price >= min);
      block.hidden = available.length === 0;
      if (!available.length) return;
      select.innerHTML = '';
      available.forEach(([n]) => {
        const option = new Option(`${n} meses sin intereses`, String(n));
        option.dataset.amount = format(Math.round(price / n), noConvert);
        select.add(option);
      });
      if (available.some(([n]) => n === current)) select.value = String(current);
      showSelected(select);
    }
  };
  window.BarradasMsi = api;

  document.addEventListener('change', (event) => {
    const select = event.target.closest && event.target.closest('.price-msi__select');
    if (!select) return;
    preferred = select.value;
    document.querySelectorAll('.price-msi__select').forEach((other) => {
      if (other !== select && [...other.options].some((o) => o.value === preferred)) other.value = preferred;
      showSelected(other);
    });
  });
}
